// ArabicKeyboardPopup.jsx
import { useRef } from "react";
import { useTranslation } from 'react-i18next';
import ArabicKeyboard from "./arabicKeyboard";
import "react-simple-keyboard/build/css/index.css";

export default function ArabicKeyboardPopup({
  value,
  setValue,
  onClose,
}) {
  const { t } = useTranslation();
  const keyboardRef = useRef(null);

  return (
    <div className="keyboard-popup">
      <ArabicKeyboard
        onChange={(input) => setValue(input)}
      />

      <button className="btn btn-sm btn-secondary mt-2" onClick={onClose}>
        {t('common.close')}
      </button>
    </div>
  );
}
